// extracted by mini-css-extract-plugin
module.exports = {"formCont":"Answers_formCont__1KDZa","answCont":"Answers_answCont__2cS_Z","firstDiv":"Answers_firstDiv__1_Mfa","addNew":"Answers_addNew__3NgzE"};